<template>
  <div>
    <template v-if="row.status === undefined || row.status<0">/</template>
    <template v-else>
      <el-tag size="mini" :type="options[row.status].tagType">{{
        options[row.status].text
      }}</el-tag>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: {
        0: {
          tagType: "info",
          text: this.$lange == "en" ? "Not yet begun" : "未开始",
        },
        1: {
          tagType: "warning",
          text: this.$lange == "en" ? "Have in hand" : "进行中",
        },
        2: {
          tagType: "success",
          text: this.$lange == "en" ? "Completed" : "已完成",
        },
        3: {
          tagType: "danger",
          text: this.$lange == "en" ? "Delay" : "延迟",
        },
      },
      status: {},
    };
  },
  props: {
    row: Object,
    index: Number,
  },
  methods: {},
  mounted() {},
};
</script>